import { render, staticRenderFns } from "./termsPurple.vue?vue&type=template&id=3119ebd0"
import script from "./termsPurple.vue?vue&type=script&lang=js"
export * from "./termsPurple.vue?vue&type=script&lang=js"
import style0 from "./termsPurple.vue?vue&type=style&index=0&id=3119ebd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports